<template>
  <div>
      <ReceiptDetails type="SALES"></ReceiptDetails>
  </div>
</template>

// <script>
import ReceiptDetails from './details.vue'
export default {
  components: { ReceiptDetails },
}
</script>

<style>

</style>